import { useForm } from 'react-hook-form';

import { ScheduleWithDeliveryFormData } from '../types';

type UseScheduleItemFormParams = {
  defaultValues?: Partial<ScheduleWithDeliveryFormData>;
};

export function useScheduleItemForm({ defaultValues }: UseScheduleItemFormParams = {}) {
  return useForm<ScheduleWithDeliveryFormData>({
    mode: 'all',
    defaultValues: {
      repetitionDayOfWeek: [],
      startHour: '',
      endHour: '',
      assignment_hour: '',
      deliveryHour: '',
      ...defaultValues,
    },
  });
}
